export default __webpack_public_path__ + "static/media/image7.9f0ff0ce.png";